import { FieldProps } from 'formik'
import { FormikDropdown } from 'formik-office-ui-fabric-react'
import { FieldStack, FieldStackItem, FormStack } from 'forms/FormStack'
import { IDropdownOption } from 'office-ui-fabric-react'
import * as React from 'react'
import { useTranslation } from 'react-i18next'

export const ProvingDetailsSimpleTransportStatusForm: React.FunctionComponent =
  () => {
    const { t } = useTranslation()

    const statusOptions: IDropdownOption[] = [
      {
        key: 'notRequired',
        text: t('dropdown.option.ResourceRequirements.status.notRequired'),
      },
      {
        key: 'open',
        text: t('dropdown.option.ResourceRequirements.status.open'),
      },
      {
        key: 'workInProgress',
        text: t('dropdown.option.ResourceRequirements.status.inProgress'),
      },
      {
        key: 'finished',
        text: t('dropdown.option.ResourceRequirements.status.finished'),
      },
    ]

    return (
      <FormStack>
        <FieldStack>
          <FieldStackItem
            name="transport.bookingStatus"
            render={(fieldProps: FieldProps<any>) => (
              <FormikDropdown
                label={t('field.bookingStatus.label')}
                {...fieldProps}
                options={statusOptions}
              />
            )}
          />
        </FieldStack>
      </FormStack>
    )
  }
